import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatisticService } from './statistic.service';

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [StatisticService],
})
export class StatisticModule {}
